import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0 mx-4 md:mx-6 my-3 md:my-4 rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20background%20with%20breaking%20news%20studio%20setting%2C%20warm%20red%20and%20dark%20tones%2C%20mysterious%20atmosphere%2C%20spotlight%20on%20center%2C%20empty%20news%20desk%2C%20cinematic%20photography%2C%20editorial%20style%2C%20rich%20contrast%2C%20professional%20lighting%2C%20bold%20dramatic%20mood%2C%20dark%20crimson%20accents%2C%20investigative%20journalism%20aesthetic&width=1800&height=1000&seq=hero-banner-911&orientation=landscape"
          alt="911吃瓜网 - 网红黑料实时追踪"
          title="911吃瓜网 - 吃瓜群众的第一手资源站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <span className="inline-block px-4 py-1.5 border border-white/40 text-white text-sm rounded-full mb-6 backdrop-blur-sm whitespace-nowrap">
          实时追踪 · 每日更新
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4 max-w-3xl">
          第一时间，吃最热的瓜
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-xl mb-8 leading-relaxed">
          聚合911吃瓜爆料、911黑料吃瓜等热门内容，每日实时追踪网红塌房、明星八卦、社会奇闻，独家爆料不断更新
        </p>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <Link
            to="/category/wanghong-tafang"
            className="px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即吃瓜
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 border border-white/50 text-white text-sm font-medium rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            投稿爆料
          </Link>
        </div>
      </div>
    </section>
  );
}